import { render, staticRenderFns } from "./PaidTransactions.vue?vue&type=template&id=37a656a5&scoped=true"
import script from "./PaidTransactions.vue?vue&type=script&lang=js"
export * from "./PaidTransactions.vue?vue&type=script&lang=js"
import style0 from "./PaidTransactions.vue?vue&type=style&index=0&id=37a656a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a656a5",
  null
  
)

export default component.exports